import { createRoute } from '@/utils/routing'

export const PAYMENT_ORDER_LIST_ROUTE = 'payment-orders'
export const PAYMENT_ORDER_VIEW_ROUTE = 'payment-orders-paymentOrderId'

export function createPaymentOrderListRoute (options = {}) {
  return createRoute(PAYMENT_ORDER_LIST_ROUTE, options)
}

export function createPaymentOrderViewRoute (paymentOrderId, options = {}) {
  if (paymentOrderId != null) {
    return createRoute(PAYMENT_ORDER_VIEW_ROUTE, {
      params: { ...options.params, paymentOrderId },
      query: options.query
    })
  }
}
